import React, { memo } from "react";
import { TagField } from "@pankod/refine-antd";
import { useNavigation, useRouterContext } from "@pankod/refine-core";
import {IQuiz} from "../../interfaces";

type RelatedQuizTagsProps = {
    quiz?: IQuiz;
    resource?: string; // defaults to "quiz"
};

const RelatedQuizTags: React.FC<RelatedQuizTagsProps> = ({quiz}) => {
    const { show, edit } = useNavigation();
    const { useLocation } = useRouterContext();
    const { pathname } = useLocation();
    const isEdit = pathname.includes("/edit/");
    const isShow = pathname.includes("/show/");

    if (!quiz?.related.length) return null;

    const parentId = quiz.parent_id ?? quiz.quiz_id;

    const sorted = [...quiz.related].sort((a, b) => {
        const aId = a.split(":")[1];
        const bId = b.split(":")[1];
        if (aId === parentId) return -1;
        if (bId === parentId) return 1;
        return 0;
    });

    return (
        <>
            {sorted.map((value) => {
                const [name, id] = value.split(":");
                if (!name || !id) return null;

                const isActive = id === quiz.quiz_id;
                const isParent = id === parentId;

                return (
                    <TagField
                        key={`${name}-${id}`}
                        value={isParent ? `★ ${name}` : name}
                        onClick={() => {
                            if (isShow) {
                                show("quiz", id);
                            } else if (isEdit) {
                                edit("quiz", id);
                            }
                        }}
                        data-active={isActive}
                        style={{
                            cursor: "pointer",
                            ...(isActive
                                ? { backgroundColor: "#dbeafe", borderColor: "#60a5fa" }
                                : {}),
                            ...(isParent
                                ? { fontWeight: "bold", backgroundColor: "#fef3c7", borderColor: "#f59e0b", borderWidth: 2, fontSize: "0.9em" }
                                : {}),
                        }}
                        aria-pressed={isActive}
                    />
                );
            })}
        </>
    );
};

export default memo(RelatedQuizTags);